/* ============================================================================
   Roon: free-tube guard  (2026-10-16)

   The "Choose Your Set" offer (buy 3 tubes, 4th free) is two cart lines:
     - build-your-own-bundle-3-tubes ($54) carrying Tube 1/2/3 + "Free 4th tube"
       as line-item properties, and
     - free-tube-your-choice ($0), one variant per scent.

   Nothing used to tie the two together after they were added. A shopper who
   built a set, abandoned checkout, came back, removed the $54 wrapper in the
   cart and bought a Discovery Set instead kept the $0 tube, and every extra
   build left another one behind. Order 431775 shipped a Discovery Set plus
   TWO orphaned free tubes; 431567 / 431667 / 431763 shipped more free tubes
   than sets.

   Rule enforced here, on every page load and after every cart change:
     free-tube quantity  <=  quantity of 3-tube wrappers that carry the
                              "Free 4th tube" property (i.e. sets built on
                              the Choose Your Set offer)
   Anything over that is removed with /cart/change.js. The $0 lines whose
   scent matches a wrapper's "Free 4th tube" are kept first. No prices are
   touched. The builder pages call reconcile() before their own /cart/add.js
   so a stale $0 tube can never ride along with a fresh set.

   Loaded from layout/theme.liquid and layout/lp-blank.liquid. Exposes
   window.RoonFreeTubeGuard = { reconcile(cart?) -> Promise<cart> }.
   ========================================================================== */
(function () {
  'use strict';
  if (window.RoonFreeTubeGuard) return;

  var FREE_HANDLE   = 'free-tube-your-choice';
  var BUNDLE_HANDLE = 'build-your-own-bundle-3-tubes';
  var ENTITLE_PROP  = 'Free 4th tube';
  var SOURCE        = 'roon-free-tube-guard';
  var inflight      = null;

  function log() {
    try { if (window.console && console.info) console.info.apply(console, ['[' + SOURCE + ']'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'include', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Decide which $0 lines must shrink or go. Returns [{id:key, quantity}]. */
  function plan(cart) {
    var items = (cart && cart.items) || [];
    var entitled = 0;
    var wanted = {};
    items.forEach(function (it) {
      if (it.handle !== BUNDLE_HANDLE) return;
      var scent = it.properties && it.properties[ENTITLE_PROP];
      if (!scent) return;                      /* a PDP/homepage bundle: no free tube promised */
      entitled += it.quantity;
      wanted[scent] = (wanted[scent] || 0) + it.quantity;
    });
    var free = items.filter(function (it) { return it.handle === FREE_HANDLE; });
    var total = free.reduce(function (a, it) { return a + it.quantity; }, 0);
    if (total <= entitled) return [];

    /* Two passes: first keep $0 lines whose scent a wrapper names (up to that
       wrapper count), then fill any leftover allowance with whatever remains.
       Everything else is cut. */
    var keepFor = {};
    var remaining = entitled;
    var named = free.filter(function (it) { return (wanted[it.variant_title] || 0) > 0; });
    var other = free.filter(function (it) { return !(wanted[it.variant_title] || 0); });
    named.forEach(function (it) {
      var k = Math.min(it.quantity, wanted[it.variant_title], remaining);
      wanted[it.variant_title] -= k; remaining -= k; keepFor[it.key] = k;
    });
    named.concat(other).forEach(function (it) {
      var have = keepFor[it.key] || 0;
      var k = Math.min(it.quantity - have, remaining);
      remaining -= k; keepFor[it.key] = have + k;
    });
    var changes = [];
    free.forEach(function (it) {
      var keep = keepFor[it.key] || 0;
      if (keep !== it.quantity) changes.push({ id: it.key, quantity: keep, title: it.title + ' / ' + it.variant_title });
    });
    return changes;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) < 0) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function change(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function apply(changes) {
    var ids = sectionIds();
    var last = changes.length - 1;
    var p = Promise.resolve(null);
    changes.forEach(function (c, i) {
      p = p.then(function () {
        var body = { id: c.id, quantity: c.quantity };
        if (i === last && ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
        log('removing orphaned free tube:', c.title, '->', c.quantity);
        return change(body);
      });
    });
    return p.then(function (cart) {
      if (!cart || cart.errors) return cart;
      /* Let the theme repaint: cart-items-component morphs from `sections`,
         cart-icon reads data.itemCount. Same shape as Horizon's CartUpdateEvent. */
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: SOURCE,
            data: { itemCount: cart.item_count, source: SOURCE, sections: cart.sections || {} }
          }
        }));
      } catch (e) {}
      return cart;
    });
  }

  /* Public: reconcile(cart?) -> Promise<cart>. Serialises overlapping calls. */
  function reconcile(cart) {
    var run = function () {
      var start = (cart && cart.items) ? Promise.resolve(cart) : fetchCart();
      return start.then(function (c) {
        if (!c) return c;
        var changes = plan(c);
        if (!changes.length) return c;
        return apply(changes).then(function (after) {
          /* One more look: a stale `cart` argument may have missed a line. */
          return fetchCart().then(function (fresh) {
            var again = plan(fresh || {});
            return again.length ? apply(again) : (fresh || after);
          });
        });
      }).catch(function (e) { log('skipped:', e && e.message); return null; });
    };
    inflight = (inflight || Promise.resolve()).then(run, run);
    var mine = inflight;
    mine.then(function () { if (inflight === mine) inflight = null; });
    return mine;
  }

  window.RoonFreeTubeGuard = { reconcile: reconcile, plan: plan };

  /* ---- triggers --------------------------------------------------------- */

  /* Any cart change the theme announces, except our own. CartAddEvent and
     CartUpdateEvent both use the 'cart:update' name; the add event carries an
     empty resource, so fall back to /cart.js. */
  document.addEventListener('cart:update', function (ev) {
    var d = ev && ev.detail;
    if (d && d.sourceId === SOURCE) return;
    if (d && d.data && d.data.source === SOURCE) return;
    var cart = d && d.resource && d.resource.items ? d.resource : null;
    reconcile(cart);
  });
  document.addEventListener('cart:refresh', function () { reconcile(); });

  /* Checkout: if a clean-up is still in flight (shopper removed the wrapper and
     tapped Checkout in the same second), finish it first, then go. */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!(form instanceof HTMLFormElement)) return;
    var isCart = form.id === 'cart-form' || /\/cart$/.test(form.getAttribute('action') || '');
    if (!isCart || !inflight || form.dataset.roonGuardPass) return;
    ev.preventDefault();
    var submitter = ev.submitter;
    inflight.then(function () {
      form.dataset.roonGuardPass = '1';
      if (submitter && form.requestSubmit) form.requestSubmit(submitter);
      else if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }, true);

  /* Page load: only bother when a cart exists. */
  function onReady() {
    var hasCart = /(^|;\s*)cart=/.test(document.cookie);
    var count = 0;
    try { count = (JSON.parse(sessionStorage.getItem('cart-count') || '{}').count) || 0; } catch (e) {}
    if (hasCart || count > 0) reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
